import { z } from 'zod';

export const cashFlowForecastQuerySchema = z.object({
  startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  weeks: z.coerce.number().int().min(1).max(52).optional(),
});
export type CashFlowForecastQuery = z.infer<typeof cashFlowForecastQuerySchema>;

export type CashForecastKind = 'invoice' | 'bill' | 'loan' | 'recurring';

export interface CashForecastItem {
  date: string;
  label: string;
  /** Signed: positive = inflow, negative = outflow. */
  amount: string;
  kind: CashForecastKind;
}

export interface CashForecastBucket {
  weekStart: string;
  weekEnd: string; // inclusive last day of the week
  inflow: string;
  outflow: string;
  net: string;
  endingBalance: string;
  items: CashForecastItem[];
}

export interface CashFlowForecastResponse {
  startDate: string;
  weeks: number;
  startingCash: string;
  endingCash: string;
  totalInflow: string;
  totalOutflow: string;
  buckets: CashForecastBucket[];
}
